/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, InputAdornment, Tooltip, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import Service from '../Service';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import CloseIcon from '@material-ui/icons/Close';
import { AlertDialog } from './../../Common/AlertDialog';
import { makeStyles } from '@material-ui/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import EditIcon from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import { Autocomplete } from '@mui/material';
import { AddDirectSupplierComponent } from './AddDirectSupplier';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import CheckIcon from '@material-ui/icons/Check';
import Collapse from '@material-ui/core/Collapse';

export default function ViewSpecialOrderListing() {
    const screenCode = 'VIEWSPECIALORDER';
    const navigate = useNavigate();
    const [date, setDate] = useState(new Date());
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        dateID: date.toISOString().split('T')[0]
    });
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [selectedSupplier, setSelectedSupplier] = useState([]);
    const [selectedFarmer, setSelectedFarmer] = useState([]);
    const [approveVCCSpecialOrderDetails, setApproveVCCSpecialOrderDetails] = useState();
    const [rejectVCCSpecialOrderDetails, setRejectVCCSpecialOrderDetails] = useState();
    const [removeSupplierDetails, setRemoveSupplierDetails] = useState([]);
    const [removeSupplierOrderDetails, setRemoveSupplierOrderDetails] = useState([]);
    const [readyToWeighmentDetails, setReadyToWeighmentDetails] = useState([]);
    const [message, setMessage] = useState("Special Order Approve Confirmation");
    const [message2, setMessage2] = useState("Special Order Reject Confirmation");
    const [message3, setMessage3] = useState("Supllier Remove Confirmation");
    const [message4, setMessage4] = useState("Ready To Weighment Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);
    const [EnableConfirmMessage3, setEnableConfirmMessage3] = useState(false);
    const [EnableConfirmMessage4, setEnableConfirmMessage4] = useState(false);
    const [isFarmerClear, setIsFarmerClear] = useState(false);
    const [farmer, setFarmer] = useState([]);
    const [supllierDetails, setSupllierDetails] = useState([]);
    const [directSupllierDetails, setDirectSupllierDetails] = useState([]);
    const [supplierOrderDeails, setSupplierOrderDeails] = useState([]);
    const [supplierOrderUpdateDeails, setSupplierOrderUpdateDeails] = useState([]);
    const [supllierVarityDetails, setSupllierVarityDetails] = useState([]);
    const [supllierVarityDetailsTwo, setSupllierVarityDetailsTwo] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [supplierData, setSupplierData] = useState({
        farmerID: 0,
        supplierTypeID: 1,
        farmerName: '',
        cropVarityID: 0,
        varietyName: '',
        quantity: 0,
        date: '',
        reaminCount: 0,
        availbaleQty: 0,
        cropForecastDetailID: 0,
        directSupplierName: '',
        nic: '',
        brNumber: '',
        directSupplierID: 0
    });
    const [openPriceDialog, setOpenPriceDialog] = useState(false);
    const [priceEditData, setPriceEditData] = useState({});

    const handlePriceChange = (e) => {
        const { name, value } = e.target;
        const decimalRegex = /^\d*\.?\d{0,2}$/;

        if (name === "realizedPrice") {
            if (value === "" || decimalRegex.test(value)) {
                if (parseFloat(value) > parseFloat(priceEditData.initialPrice)) {
                    toast.error("Realized Price cannot exceed Initial Price");
                    return;
                }
                setPriceEditData({ ...priceEditData, [name]: value });
            }
        } else {
            setPriceEditData({ ...priceEditData, [name]: value });
        }
    };

    const handleSavePrice = async () => {
        if (priceEditData.realizedPrice <= 0) {
            toast.error("Price must be greater than 0");
            return;
        }
        var factoryRes = operationEntityList.find(x => x.factoryID == priceEditData.operationEntityID)
        let saveModel = {
            specialOrderID: parseInt(priceEditData.specialOrderID),
            operationEntityID: priceEditData.operationEntityID,
            operationEntityCode: factoryRes.factoryCode,
            factoryName: factoryRes.factoryName,
            cropID: priceEditData.cropID,
            productCode: priceEditData.productCode,
            productName: priceEditData.productName,
            orderDate: priceEditData.orderDate,
            quantity: parseFloat(priceEditData.quantity),
            editStatus: 2, //Edit Price View Special Order Screen
            realizedPrice: parseFloat(priceEditData.realizedPrice),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.UpdateSpecialOrder(saveModel)
        if (res.statusCode === "Success") {
            toast.success(res.message);
            setOpenPriceDialog(false);
            trackPromise(GetSpecialOrdersForVCCByVccDate());
        } else {
            toast.error(res.message);
        }
    };

    const viewSpecialOrderSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center Required'),
        dateID: Yup.date().min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            dateID: formData.dateID
        },
        validationSchema: viewSpecialOrderSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetSpecialOrdersForVCCByVccDate())
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSPECIALORDER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        });
        trackPromise(GetAllGroups());
    }

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setTableData([]);
    }, [formik.values.operationEntityID, formik.values.dateID]);

    useEffect(() => {
        supplierQuntityCal(supplierData.quantity);
    }, [supplierData.quantity]);

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
        setIsFarmerClear(!isFarmerClear);
    }, [formik.values.operationEntityID]);

    async function GetAllGroups() {
        var res = await Service.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await Service.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function clearAll() {
        setTableData([]);
        setValues({
            ...values,
            operationEntityID: "0",
            dateID: date.toISOString().split('T')[0]
        });
    }

    async function GetRouteByFactoryID() {
        var res = await Service.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function GetSpecialOrdersForVCCByVccDate() {
        var res = await Service.GetSpecialOrdersForVCCByVccDate(formik.values.operationEntityID, formik.values.dateID);
        if (res != null) {
            res.sort((a, b) => a.productName > b.productName ? 1 : -1);
            setTableData(res);
        }
    }

    async function GetSupplierDetailsForOrder(data) {
        var res = await Service.GetSupplierDetailsForOrder(data.operationEntityID, data.cropID, data.orderDate);
        if (res != null) {
            setSupllierDetails(res);
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var result = await Service.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID);
        result.forEach(x => {
            x.givenName = x.givenName == null || x.givenName == "" ? x.farmerCode : x.givenName
        })
        setFarmer(result);
    }

    async function GetDirectSupplierDetails(data) {
        var res = await Service.GetDirectSupplierDetails(data.operationEntityID);
        if (res != null) {
            let newRes = res.filter(x => x.isActive == 1)
            setDirectSupllierDetails(newRes);
        }
    }

    async function GetSupplierCropVarityQuntityDetails(cropID) {
        var res = await Service.GetSupplierCropVarityQuntityDetails(cropID);
        if (res != null) {
            setSupllierVarityDetails(res);
            setSupllierVarityDetailsTwo(res);
        }
    }

    function supplierQuntityCal(data) {
        setSupplierData({
            ...supplierData,
            reaminCount: (supplierOrderDeails.reaminingQuantity - data) < 0 ? 0 : (supplierOrderDeails.reaminingQuantity - data)
        });
    }

    async function ApproveVCCSpecialOrder(value) {
        let model = {
            specialOrderID: parseInt(value.specialOrderID),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.ApproveVCCSpecialOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            GetSpecialOrdersForVCCByVccDate();
        } else {
            toast.error(res.message);
        }
    }

    async function RejectVCCSpecialOrder(value) {
        let model = {
            specialOrderID: parseInt(value.specialOrderID),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.RejectVCCSpecialOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            GetSpecialOrdersForVCCByVccDate();
        } else {
            toast.error(res.message);
        }
    }

    function EditPrice(data) {
        setPriceEditData(data);
        setOpenPriceDialog(true);
    }

    function ApproveVCCSpecialOrderPopUp(data) {
        setEnableConfirmMessage(true);
        setApproveVCCSpecialOrderDetails(data)
    }

    function RejectVCCSpecialOrderPopUp(data) {
        setEnableConfirmMessage2(true);
        setRejectVCCSpecialOrderDetails(data)
    }

    function removeSupplierPopUp(data, data2) {
        setEnableConfirmMessage3(true);
        setRemoveSupplierDetails(data2);
        setRemoveSupplierOrderDetails(data);
    }

    function readyToWeighmentPopUp(data) {
        setReadyToWeighmentDetails(data)
        setEnableConfirmMessage4(true);
    }

    const [open, setOpen] = useState(false);
    const [openOne, setOpenOne] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const handleClickOpen = (data) => {
        setIsUpdate(false);
        setSupplierOrderDeails(data);
        trackPromise(GetSupplierCropVarityQuntityDetails(data.cropID),
            GetSupplierDetailsForOrder(data), GetDirectSupplierDetails(data))
        setSupplierData({
            ...supplierData,
            reaminCount: data.reaminingQuantity,
        });
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setIsUpdate(false);
        addSupplierClearFields();
    };

    const handleClickOpenOne = (data) => {
        setOpenOne(true);
    };
    const handleCloseOne = () => {
        setOpenOne(false);
    };

    async function setUpdateSupplier(row, historyRow) {
        trackPromise(GetSupplierDetailsForOrder(row),
            GetDirectSupplierDetails(row));
        setIsUpdate(true);
        setOpen(true);
        setSupplierOrderDeails(row);
        setSupplierOrderUpdateDeails(historyRow);
        setSupplierData({
            ...supplierData,
            supplierTypeID: historyRow.isDirectSupplier == false ? 1 : 2,
            farmerName: historyRow.givenName,
            varietyName: historyRow.varietyName,
            reaminCount: row.reaminingQuantity,
            date: row.orderDate.split('T')[0],
            quantity: historyRow.acceptedQuantity,
            farmerID: historyRow.farmerID,
            cropVarityID: historyRow.cropVarietyID,
            cropForecastDetailID: historyRow.cropForecastDetailID,
            availbaleQty: historyRow.acceptedQuantity
        })
    }

    function addSupplierClearFields() {
        setSupplierData({
            ...supplierData,
            farmerID: 0,
            supplierTypeID: 1,
            farmerName: '',
            cropVarityID: 0,
            varietyName: '',
            quantity: 0,
            date: '',
            reaminCount: 0,
            availbaleQty: 0,
            cropForecastDetailID: 0,
            directSupplierName: '',
            nic: '',
            brNumber: ''
        });
    }

    function handleAddSupplierChange(e) {
        const target = e.target;
        const value = target.value

        setSupplierData({
            ...supplierData,
            [e.target.name]: value
        });
    }

    function confirmData(y) {
        if (y) {
            ApproveVCCSpecialOrder(approveVCCSpecialOrderDetails);
        }
    }

    function confirmData2(y) {
        if (y) {
            RejectVCCSpecialOrder(rejectVCCSpecialOrderDetails);
        }
    }

    function confirmData3(y) {
        if (y) {
            removeSupllier(removeSupplierDetails, removeSupplierOrderDetails);
        }
    }

    function confirmData4(y) {
        if (y) {
            ApproveSpecialOrderReadyToWeighment(readyToWeighmentDetails)
        }
    }

    async function ApproveSpecialOrderReadyToWeighment(readyToWeighmentDetails) {
        var res = await Service.ApproveSpecialOrderReadyToWeighment(readyToWeighmentDetails)

        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
        trackPromise(GetSpecialOrdersForVCCByVccDate());
    }

    async function removeSupllier(supplierDetails, SupplierOrderDetails) {
        var res = await Service.RemoveSpecialOrderSuppliers(supplierDetails, SupplierOrderDetails)
        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
        trackPromise(GetSpecialOrdersForVCCByVccDate());
    }

    async function AddSuppliers() {
        setIsLoading(true);
        if (isUpdate == false) {
            if (supplierData.farmerID != 0 && supplierData.cropVarityID != 0 && supplierData.quantity != 0) {
                var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,2})?$');
                if (reg.test(supplierData.quantity) == true) {
                    var sumQty = supplierOrderDeails.quantity - supplierOrderDeails.returnQuantity
                    if (supplierData.quantity <= (sumQty - supplierOrderDeails.acceptedQuantity)) {
                        const found = supplierOrderDeails.farmerModel.find(x => x.cropVarietyID == supplierData.cropVarityID && x.farmerID == supplierData.farmerID)
                        if (found == undefined) {
                            var res = await Service.AddSpecialOrderSuppliers(supplierOrderDeails, supplierData)
                            if (res.statusCode === "Success") {
                                toast.success(res.message);
                                handleClose();
                            } else {
                                toast.error(res.message);
                            }
                            trackPromise(GetSpecialOrdersForVCCByVccDate());
                        }
                        else {
                            toast.error('Can not add same crop from same supplier');
                        }
                    }
                    else {
                        toast.error('Can not be greater than requested quantity');
                    }
                }
                else {
                    toast.error("Allow Only Numbers");
                }
            }
            else {
                toast.error('Fill The All Required Fields');
            }
        }
        else {
            if (supplierData.quantity != 0) {
                var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,2})?$');
                if (reg.test(supplierData.quantity) == true) {
                    var sumQty = supplierOrderDeails.acceptedQuantity - supplierData.availbaleQty
                    if ((sumQty + parseFloat(supplierData.quantity)) <= (supplierOrderDeails.quantity - supplierOrderDeails.returnQuantity)) {
                        trackPromise(GetSupplierCropVarityQuntityDetails(supplierData.farmerID));
                        var res = await Service.EditSpecialOrderSuppliers(supplierOrderDeails, supplierOrderUpdateDeails, supplierData)
                        if (res.statusCode === "Success") {
                            toast.success(res.message);
                            handleClose();
                        } else {
                            toast.error(res.message);
                        }
                        trackPromise(GetSpecialOrdersForVCCByVccDate());
                    }
                    else {
                        toast.error('Can not be greater than requested quantity');
                    }
                }
                else {
                    toast.error("Allow Only Numbers");
                }
            }
            else {
                toast.error('Fill The All Required Fields');
            }
        }
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {
            setSelectedFarmer(data);
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            setSelectedFarmer(data);
            var nameP = 'farmerID';
            var valueV = data.farmerID;
            setSupplierData({
                ...supplierData,
                farmerID: valueV.toString(),
            });
        }
    }

    function handleSearchDropdownChangePrefferdNameOne(data, e) {
        if (data === undefined || data === null) {
            setSelectedSupplier(data);
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            setSelectedSupplier(data);
            var nameP = 'directSupplierID';
            var valueV = data.directSupplierID;
            setSupplierData({
                ...supplierData,
                farmerID: valueV.toString(),
            });
        }
    }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
            (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.givenName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput ||
                option.farmerCode.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const filterOptionsOne = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.supplierName && option.supplierName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.supplierName !== null && option.nic !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.supplierName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const PopUpStyle = makeStyles((theme) => ({
        root: {
            '& > *': {
                width: '25ch'
            }
        }
    }));

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const popUpClass = PopUpStyle();
    const classes = useStyles();

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = useState(true);
        const classes = useRowStyles();

        const isDisabled = new Date(formik.values.dateID) < new Date().setHours(0, 0, 0, 0);

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        {row.statusID == 4 ?
                            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton> : null}
                    </TableCell>
                    <TableCell align="left" component="th" scope="row">{row.productName}</TableCell>
                    <TableCell align="left">{row.productCode}</TableCell>
                    <TableCell align="right">{parseFloat(row.realizedPrice).toFixed(2)}</TableCell>
                    <TableCell align="right">{parseFloat(row.quantity).toFixed(2)}</TableCell>
                    <TableCell align="right">{parseFloat(row.acceptedQuantity).toFixed(2)}</TableCell>
                    <TableCell align="right">{parseFloat(row.reaminingQuantity).toFixed(2)}</TableCell>
                    <TableCell align="center">
                        {row.statusID == 2 ?
                            <Chip size="small" label="New" style={{ color: 'gray' }} /> :
                            row.statusID == 4 ?
                                <Chip size="small" label="Approved" style={{ color: 'green' }} /> :
                                <Chip size="small" label="Rejected" style={{ color: 'red' }} />
                        }
                    </TableCell>
                    <TableCell align="center">
                        {row.statusID == 2 ?
                            <>
                                <Tooltip title={isDisabled ? "Cannot edit previous date data" : "Edit"}>
                                    <span>
                                        <IconButton 
                                            aria-label="edit" 
                                            onClick={() => !isDisabled && EditPrice(row)}
                                            disabled={isDisabled}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip title={isDisabled ? "Cannot approve previous date data" : "Approve"}>
                                    <span>
                                        <IconButton 
                                            aria-label="approve" 
                                            onClick={() => !isDisabled && ApproveVCCSpecialOrderPopUp(row)}
                                            disabled={isDisabled}
                                        >
                                            <CheckIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip title={isDisabled ? "Cannot reject previous date data" : "Reject"}>
                                    <span>
                                        <IconButton 
                                            aria-label="reject" 
                                            onClick={() => !isDisabled && RejectVCCSpecialOrderPopUp(row)}
                                            disabled={isDisabled}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </> :
                            row.statusID == 4 && row.statusID != 1 && row.reaminingQuantity > 0 ?
                                <Tooltip title={isDisabled ? "Cannot add supplier to previous date data" : "Add Supplier"}>
                                    <span>
                                        <IconButton 
                                            aria-label="add-supplier" 
                                            onClick={() => !isDisabled && handleClickOpen(row)}
                                            disabled={isDisabled}
                                        >
                                            <AddBoxIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                : null}
                    </TableCell>
                </TableRow>
                <TableRow>
                    {row.statusID == 4 ?
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                {row.farmerModel.length != 0 ?
                                    <Box margin={1} marginLeft={17}>
                                        <Typography variant="h7" gutterBottom component="div">
                                            <b>Supplier Details</b>
                                        </Typography>
                                        <Table size="small" aria-label="purchases">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>Supplier</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>Supplier Type</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop Variety</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Accepted Qty</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {row.farmerModel.map((historyRow) => (
                                                    <TableRow key={historyRow.specialOrderFarmerMappingID}>
                                                        <TableCell align="left" component="th" scope="row">
                                                            {historyRow.givenName}
                                                        </TableCell>
                                                        <TableCell align="left" component="th" scope="row">
                                                            {historyRow.isDirectSupplier == true ? "Direct Supplier" : "Farmer"}
                                                        </TableCell>
                                                        <TableCell align="left">{historyRow.varietyName}</TableCell>
                                                        <TableCell align="right">{parseFloat(historyRow.acceptedQuantity).toFixed(2)}</TableCell>
                                                        <TableCell align="center">
                                                            {historyRow.statusID == 1 ?
                                                                <>
                                                                    <Tooltip title={isDisabled ? "Cannot remove supplier from previous date data" : "Remove Supplier"}>
                                                                        <span>
                                                                            <IconButton 
                                                                                aria-label="remove-supplier"
                                                                                onClick={() => !isDisabled && removeSupplierPopUp(row, historyRow)}
                                                                                disabled={isDisabled}
                                                                            >
                                                                                <Delete />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                    <Tooltip title={isDisabled ? "Cannot edit supplier from previous date data" : "Edit Supplier"}>
                                                                        <span>
                                                                            <IconButton 
                                                                                aria-label="edit-supplier"
                                                                                onClick={() => !isDisabled && setUpdateSupplier(row, historyRow)}
                                                                                disabled={isDisabled}
                                                                            >
                                                                                <EditIcon />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                    <Tooltip title={isDisabled ? "Cannot process previous date data" : "Ready To Weighment"}>
                                                                        <span>
                                                                            <IconButton 
                                                                                aria-label="ready-weighment"
                                                                                onClick={() => !isDisabled && readyToWeighmentPopUp(historyRow)}
                                                                                disabled={isDisabled}
                                                                            >
                                                                                <CheckIcon />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                </>
                                                                : historyRow.statusID == 3 ? <Chip label="Processing" variant="outlined" color='success' />
                                                                    : historyRow.statusID == 5 ? <Chip label="Complete" variant="outlined" color='success' />
                                                                        : <Chip label="Ready To Weighment" variant="outlined" color='success' />}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                    : <Typography variant="h7" gutterBottom component="div">
                                        <b>No Supplier Details</b>
                                    </Typography>}
                            </Collapse>
                        </TableCell> : null}
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <>
            <LoadingComponent />
            <Page title="View Special Order |  FAPS">
                <Container>
                    <CommonPageHeader
                        btname="Add"
                        pageName="View Special Order"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Fresh Collection Center</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        id="outlined-start-adornment"
                                        size="small"
                                        label="Date *"
                                        type="Date"
                                        value={formik.values.dateID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('dateID')}
                                        error={Boolean(touched.dateID && errors.dateID)}
                                        helperText={touched.dateID && errors.dateID}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"></InputAdornment>
                                        }}
                                    >
                                    </TextField>
                                    <Grid item md={4} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="left" spacing={2}>
                        {tableData.length != 0 ?
                            <Button
                                type="button"
                                color='secondary'
                                variant="outlined"
                                disabled={new Date(formik.values.dateID) < new Date().setHours(0, 0, 0, 0)}
                                onClick={() => handleClickOpenOne()}
                            >
                                Add Direct Supplier
                            </Button>
                            : null}
                    </Stack>
                    <br />
                    {tableData.length != 0 ?
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                <Paper className={classes.root}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="collapsible table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell />
                                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Price</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Requested Qty</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Accepted Qty</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Remaining Qty</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody >
                                                {tableData.map((row) => (
                                                    <Row key={row.specialOrderID} row={row} />
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Card>
                        </Stack> : <SearchNotFound searchQuery="View Special Order" />}
                </Container>
                <Dialog fullWidth={true} open={open} maxWidth="lg" aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{isUpdate == false ? "Add Supplier" : "Edit Supplier"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {isUpdate == false ?
                                <>
                                    Remaining Qty : {parseFloat(supplierData.reaminCount).toFixed(2)}
                                    <br />
                                </> : null}

                            <br />
                            <Container>
                                <Stack spacing={3}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            id="outlined-basic"
                                            name='supplierTypeID'
                                            variant="outlined"
                                            label="Supplier Type *"
                                            value={supplierData.supplierTypeID}
                                            onChange={(e) => { handleAddSupplierChange(e) }}
                                            InputProps={{
                                                readOnly: isUpdate ? true : false
                                            }}
                                        >
                                            <MenuItem value={1}> Registered Supplier</MenuItem>
                                            <MenuItem value={2}> Direct Supplier</MenuItem>
                                        </TextField>
                                        {supplierData.supplierTypeID == 1 ?
                                            <>
                                                {isUpdate == false ?
                                                    <Autocomplete
                                                        fullWidth
                                                        key={isFarmerClear}
                                                        clearOnEscape
                                                        id="farmerID"
                                                        options={farmer}
                                                        filterOptions={filterOptions}
                                                        getOptionLabel={(option) => `${option.givenName} - ${option.nic}`}
                                                        onChange={(e, value) => handleSearchDropdownChangePrefferdName(value, e)}
                                                        renderOption={(props, option) => (
                                                            <li {...props}>
                                                                {`${option.givenName} - ${option.nic}`}
                                                            </li>
                                                        )}
                                                        renderInput={(params) =>
                                                            <TextField {...params}
                                                                variant="outlined"
                                                                name="farmerID"
                                                                label="Supplier Preferred Name / NIC *"
                                                                size="small"
                                                                fullWidth
                                                                helperText={touched.farmerID && errors.farmerID}
                                                                error={Boolean(touched.farmerID && errors.farmerID)}
                                                            />
                                                        }
                                                    />
                                                    :
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-basic"
                                                        size="small"
                                                        label="Supplier *"
                                                        variant="outlined"
                                                        name='farmerName'
                                                        value={supplierData.farmerName}
                                                        onChange={(e) => { handleAddSupplierChange(e) }}
                                                        InputProps={{
                                                            readOnly: true
                                                        }}
                                                    />
                                                }
                                            </>
                                            :
                                            <>
                                                {isUpdate == false ?
                                                    <Autocomplete
                                                        fullWidth
                                                        key={isFarmerClear}
                                                        clearOnEscape
                                                        id="directSupplierID"
                                                        options={directSupllierDetails}
                                                        filterOptions={filterOptionsOne}
                                                        getOptionLabel={(option) => `${option.supplierName} - ${option.nic}`}
                                                        onChange={(e, value) => handleSearchDropdownChangePrefferdNameOne(value, e)}
                                                        renderOption={(props, option) => (
                                                            <li {...props}>
                                                                {`${option.supplierName} - ${option.nic}`}
                                                            </li>
                                                        )}
                                                        renderInput={(params) =>
                                                            <TextField {...params}
                                                                variant="outlined"
                                                                name="directSupplierID"
                                                                label="Direct Supllier *"
                                                                size="small"
                                                                fullWidth
                                                                helperText={touched.farmerID && errors.farmerID}
                                                                error={Boolean(touched.farmerID && errors.farmerID)}
                                                            />
                                                        }
                                                    />
                                                    :
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-basic"
                                                        size="small"
                                                        label="Direct Supllier *"
                                                        variant="outlined"
                                                        name='supplierName'
                                                        value={supplierData.farmerName}
                                                        onChange={(e) => { handleAddSupplierChange(e) }}
                                                        InputProps={{
                                                            readOnly: true
                                                        }}
                                                    />
                                                }
                                            </>}
                                        {isUpdate == false ?
                                            <>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    size="small"
                                                    id="outlined-basic"
                                                    name='cropVarityID'
                                                    variant="outlined"
                                                    label="Crop Variety *"
                                                    value={supplierData.cropVarityID}
                                                    onChange={(e) => { handleAddSupplierChange(e) }}
                                                >
                                                    <MenuItem key={0} value={0}> Select Crop Variety</MenuItem>
                                                    {supllierVarityDetailsTwo.map((option) => (
                                                        <MenuItem key={option.productVarietyID} value={option.productVarietyID}>
                                                            {option.varietyName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </> :
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label="Crop Variety *"
                                                variant="outlined"
                                                name='varietyName'
                                                value={supplierData.varietyName}
                                                onChange={(e) => { handleAddSupplierChange(e) }}
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        }
                                        <TextField
                                            fullWidth
                                            id="outlined-basic"
                                            size="small"
                                            label="Quantity *"
                                            variant="outlined"
                                            name='quantity'
                                            value={supplierData.quantity}
                                            onChange={(e) => { handleAddSupplierChange(e) }}
                                            InputProps={{
                                                inputProps: {
                                                    step: 0.01,
                                                    type: 'number',
                                                },
                                            }}
                                            onKeyDown={(evt) =>
                                                (evt.key === "-") && evt.preventDefault()
                                            }
                                            onWheel={event => event.target.blur()}
                                        />
                                    </Stack>
                                </Stack>
                            </Container>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary">
                            CANCEL
                        </Button>
                        <LoadingButton
                            color="secondary"
                            onClick={AddSuppliers}
                            loading={isLoading}
                            variant="text"
                        >
                            {isUpdate == false ? "ADD" : "UPDATE"}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
                <Dialog
                    fullWidth
                    open={openPriceDialog}
                    onClose={() => setOpenPriceDialog(false)}
                    aria-labelledby="price-edit-dialog-title"
                >
                    <DialogTitle id="price-edit-dialog-title">Edit Supplier Price</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Container>
                                <Stack spacing={3} style={{ marginTop: '10px' }}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            label="Crop Variety"
                                            size="small"
                                            variant="outlined"
                                            value={priceEditData.productName}
                                            InputProps={{ readOnly: true }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Crop SKU"
                                            size="small"
                                            variant="outlined"
                                            value={priceEditData.productCode}
                                            InputProps={{ readOnly: true }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Price *"
                                            size="small"
                                            variant="outlined"
                                            name="realizedPrice"
                                            type="number"
                                            value={priceEditData.realizedPrice}
                                            onChange={handlePriceChange}
                                            inputProps={{
                                                step: 0.01,
                                                min: 0,
                                            }}
                                            onKeyDown={(evt) => evt.key === "-" && evt.preventDefault()}
                                            onWheel={(event) => event.target.blur()}
                                        />
                                    </Stack>
                                </Stack>
                            </Container>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenPriceDialog(false)} color="secondary">
                            CANCEL
                        </Button>
                        <LoadingButton
                            color="secondary"
                            onClick={handleSavePrice}
                            loading={isLoading}
                            variant="text"
                        >
                            UPDATE
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to approve this Special Order ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
                            discription={"Are you sure want to reject this Special Order ?"} setViewPopup={setEnableConfirmMessage2} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData3} headerMessage={message3} viewPopup={EnableConfirmMessage3}
                            discription={"Are you sure want to remove this supplier ?"} setViewPopup={setEnableConfirmMessage3} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData4} headerMessage={message4} viewPopup={EnableConfirmMessage4}
                            discription={"Are you sure want to approve this order ?"} setViewPopup={setEnableConfirmMessage4} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AddDirectSupplierComponent openOne={openOne} handleCloseOne={handleCloseOne} groupID={formik.values.groupID}
                            operationEntityID={formik.values.operationEntityID} />
                    </Grid>
                </div>
            </Page>
        </>
    );
}